import type { RentalPayoutsRange, TransactionFilters } from '../types/transactionTypes'
import type { TransactionQueryParams } from './transactionQueryParams'

export const transactionKeys = {
  all: ['transactions'] as const,
  lists: () => [...transactionKeys.all, 'list'] as const,
  list: (filters: TransactionFilters) => [...transactionKeys.lists(), filters] as const,
  details: () => [...transactionKeys.all, 'detail'] as const,
  detail: (transactionId: string) => [...transactionKeys.details(), transactionId] as const,
  filters: () => [...transactionKeys.all, 'filters'] as const,
  /** Keyed on the built params so equivalent filter states share one PDF. */
  statement: (params: TransactionQueryParams) =>
    [...transactionKeys.all, 'statement', params] as const,
  rentalPayouts: (range: RentalPayoutsRange) =>
    [...transactionKeys.all, 'rentalPayouts', range] as const,
}
